// ═══════════════════════════════════════════════════════════════════════════════
// Settings Validation Schemas
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { FONT_SIZE, SUPPORTED_LANGUAGES, THEME } from '../constants/index.js';
import { nicknameSchema, timezoneSchema, usageRegionSchema } from './common.schema.js';
const supportedLanguageSchema = z.enum(SUPPORTED_LANGUAGES);
// ── Update User Settings Input Schema ──
export const updateUserSettingsInputSchema = z.object({
    nickname: nicknameSchema.optional(),
    language: supportedLanguageSchema.optional(),
    timezone: timezoneSchema.optional(),
    theme: z.enum([
        THEME.LIGHT,
        THEME.DARK,
        THEME.SYSTEM,
    ]).optional(),
    fontSize: z.enum([
        FONT_SIZE.XSMALL,
        FONT_SIZE.SMALL,
        FONT_SIZE.MEDIUM,
        FONT_SIZE.LARGE,
        FONT_SIZE.XLARGE,
    ]).optional(),
    notifyEmailActivity: z.boolean().optional(),
    autoTranslationEnabled: z.boolean().optional(),
    usageRegion: usageRegionSchema.optional(),
});
// ── Account removal (password may be required by provider policy) ──
export const accountRemovalRequestBodySchema = z.object({
    password: z.string().min(1, 'Password is required').optional(),
});
// ── Accept Consent Input Schema ──
export const acceptConsentInputSchema = z.object({
    version: z.string().min(1, 'Consent version is required'),
    locale: supportedLanguageSchema,
});
//# sourceMappingURL=settings.schema.js.map